import type {
  AdAdvertiserInput,
  AdAdvertiserView,
  AdCampaignAdminView,
  AdCampaignInput,
  AdLeadAdminView,
} from '@repo/shared'
import { json, request } from './api'
import { env } from './env'
import type { GetToken } from './lib/auth'

export type AdStatusTarget = 'pending_review' | 'approved' | 'paused' | 'rejected'

/** 광고 관리 화면의 API (apps/api/src/routes/admin-ads.ts) */
export const adsApi = {
  overview: (getToken: GetToken) =>
    request<{ advertisers: AdAdvertiserView[]; campaigns: AdCampaignAdminView[] }>(
      getToken,
      '/admin/ads',
    ),
  createAdvertiser: (getToken: GetToken, input: AdAdvertiserInput) =>
    request<{ advertiser: AdAdvertiserView }>(
      getToken,
      '/admin/ads/advertisers',
      json('POST', input),
    ),
  updateAdvertiser: (getToken: GetToken, id: string, input: AdAdvertiserInput) =>
    request<{ advertiser: AdAdvertiserView }>(
      getToken,
      `/admin/ads/advertisers/${encodeURIComponent(id)}`,
      json('PUT', input),
    ),
  createCampaign: (getToken: GetToken, input: AdCampaignInput) =>
    request<{ id: string }>(getToken, '/admin/ads/campaigns', json('POST', input)),
  updateCampaign: (getToken: GetToken, id: string, input: AdCampaignInput) =>
    request<{ id: string }>(
      getToken,
      `/admin/ads/campaigns/${encodeURIComponent(id)}`,
      json('PUT', input),
    ),
  setStatus: (getToken: GetToken, id: string, status: AdStatusTarget) =>
    request<{ id: string }>(
      getToken,
      `/admin/ads/campaigns/${encodeURIComponent(id)}/status`,
      json('POST', { status }),
    ),
  leads: (getToken: GetToken) =>
    request<{ items: AdLeadAdminView[] }>(getToken, '/admin/ads/leads'),
  /** 살아 있는 문의 CSV 를 내려받는다 (서버가 작업 기록에 남긴다) */
  downloadLeads: async (getToken: GetToken, campaignId?: string) => {
    const token = await getToken()
    const qs = campaignId ? `?campaignId=${encodeURIComponent(campaignId)}` : ''
    const res = await fetch(`${env.API_URL}/admin/ads/leads.csv${qs}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`)
    const url = URL.createObjectURL(await res.blob())
    const a = document.createElement('a')
    a.href = url
    a.download = `ad-leads${campaignId ? `-${campaignId}` : ''}.csv`
    a.click()
    URL.revokeObjectURL(url)
  },
}
